<template>
  <transition name="fade" mode="out-in" appear>
    <section class="ls-login-parent">
      <div class="ls-login-inner">
        <div class="ls-login-container">
          <div class="ls-login-box">
            <h1 class="ls-login-logo">
              <img src="../../../../assets/img/logo.svg">
            </h1>
            <flash-message></flash-message>
            <form class="ls-form ls-login-form" role="form" @submit.prevent="validateBeforeSubmit">
              <fieldset>
                <label class="ls-label" :class="{'ls-error': errors.has($t('login.password')) }">
                  <div class="ls-prefix-group">
                    <b class="ls-label-text ls-hidden-accessible">{{ $t('login.subdomain')}}</b>
                    <span class="ls-label-text-prefix"><i class="fa fa-indent" aria-hidden="true"></i></span>
                    <input
                      type="text"
                      v-model="user.subdomain"
                      v-validate="'required'"
                      class="form-control"
                      :placeholder="$t('login.you_domain')"
                      :name="$t('login.subdomain')" />
                  </div>
                  <small v-show="errors.has($t('login.subdomain'))" class="ls-help-message">{{ errors.first($t('login.subdomain')) }}</small>
                </label>
                <label class="ls-label" :class="{'ls-error': errors.has($t('login.mail')) }">
                  <b class="ls-label-text ls-hidden-accessible">{{ $t('login.user') }}</b>
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                    <input
                      id="email"
                      class="form-control"
                      type="email"
                      v-model="user.email"
                      v-validate="'required|email'"
                      :placeholder="$t('login.mail')"
                      :name="$t('login.mail')" />
                  </div>
                  <small v-show="errors.has($t('login.mail'))" class="ls-help-message">{{ errors.first($t('login.mail')) }}</small>
                </label>
                <label class="ls-label" :class="{'ls-error': errors.has($t('login.password')) }">
                  <b class="ls-label-text ls-hidden-accessible">{{ $t('login.password') }}</b>
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-lock" aria-hidden="true"></i></span>
                    <input
                      id="password"
                      class="form-control"
                      v-model="user.password"
                      name="user.password"
                      type="password"
                      v-validate="'required'"
                      :placeholder="$t('login.password')"
                      :name="$t('login.password')" />
                  </div>
                  <small v-show="errors.has($t('login.password'))" class="ls-help-message">{{ errors.first($t('login.password')) }}</small>
                </label>
                <router-link :to="{ name: 'recover_password'}" :title="$t('login.forgot_password')" class="forgot-password ls-color-theme">{{ $t('login.forgot_password') }}</router-link>
                <button id="login" class="ls-btn-primary ls-btn-block ls-btn-lg" v-bind:disabled="buttonText !== $t('login.login')" type="submit">{{ buttonText }}</button>

              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </section>
  </transition>
</template>
<script>
  import { mapActions, mapMutations } from 'vuex'

  export default {
    data () {
      return {
        buttonText: this.$t('login.login'),
        errorLogin: false,
        user: {
          email: '',
          password: '',
          subdomain: ''
        }
      }
    },
    methods: {
      ...mapActions(['loadFullUser', 'attemptLoginWithSubdomain']),
      ...mapMutations(['clearFlash', 'addFlash']),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(this.doLogin)
      },
      doLogin (success) {
        if (!success) return
        const user = this.user
        this.$loader.show()
        this.buttonText = this.$t('login.entering')
        this.clearFlash()
        this.attemptLoginWithSubdomain({...user}).then(this.afterLogin)
      },
      afterLogin (response) {
        window.localStorage.setItem('userPermissions', JSON.stringify([]))
        if (response && response.status === 200) {
          window.localStorage.removeItem('userToken')
          window.location = response.data.url_portal + '/auth?token=' + response.data.auth_token
        } else {
          window.stop()
          this.$loader.hide()
          this.buttonText = this.$t('login.login')
        }
      },
      goToSignup () {
        this.$router.push('/signup')
      }
    },
    mounted () {
      this.clearFlash()
    }
  }
</script>
<style lang="scss" scoped>
  @-moz-document url-prefix() {
    .ls-prefix-group {
      margin: 0!important;
    }
    .forgot-password {
      margin-top: 11px!important;
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  .forgot-password {
    font-size: 11px;
    display: initial;
    top: 5px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// LoginWithSubdomain.vue?158a3e39